import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiGet } from "../api";
import type { Schemas } from "../../api/types";
import { POLL_BASE_MS } from "./intervals";

export type Dashboard = Schemas["Dashboard"];
export type DashboardVAT = Schemas["DashboardVAT"];

/** The "Přehled" figures for a year (CZK minor units, issued documents only). */
export function useDashboard(companyId: string, year: number) {
  return useQuery<Dashboard>({
    queryKey: ["companies", companyId, "documents", "dashboard", year],
    queryFn: () => apiGet<Dashboard>(`/companies/${companyId}/dashboard?year=${year}`),
    refetchInterval: POLL_BASE_MS,
    // Another year replaces the figures in place, without a spinner — never
    // another company's figures.
    placeholderData: (prev, prevQuery) => (prevQuery?.queryKey[1] === companyId ? keepPreviousData(prev) : undefined),
  });
}
